var MeetAjaxForProduct = function ajaxConstructor(settings) {
  var default_Data = {
    container: "#infinteLoop", // Assure-toi que ce sélecteur est correct
    method: "scroll",
    callback: null,
    loadingText: "Chargement des produits suivants...",
    pagination: "#infinitePagination", // Corrigé ici
    offset: 0,
  };

  var data = settings || {};
  this.data = Object.assign({}, default_Data, data); // Correction du merge

  this.meetProductClick = this.meetProductClick.bind(this);
  this.meetProductScroll = this.meetProductScroll.bind(this);
  this.meetProductDestroy = this.meetProductDestroy.bind(this);
  this.meetStopProductMultipleClicks = this.meetStopProductMultipleClicks.bind(this);
  this.meetProductPaginationlnView = this.meetProductPaginationlnView.bind(this);

  this.meetProductpagination = document.querySelector(this.data.pagination);
  this.meetProductcontainer = document.querySelector(this.data.container);

  this.meetProductInitialize();
};

MeetAjaxForProduct.prototype.meetProductInitialize = function () {
  if (this.meetProductcontainer) {
    var methods = {
      click: this.meetProductClick,
      scroll: this.meetProductScroll,
    };
    if (methods[this.data.method]) {
      methods[this.data.method]();
    }
  }
};

MeetAjaxForProduct.prototype.meetProductScroll = function () {
  if (this.meetProductpagination) {
    document.addEventListener("scroll", this.meetProductPaginationlnView);
    window.addEventListener("resize", this.meetProductPaginationlnView);
    window.addEventListener("orientationchange", this.meetProductPaginationlnView);
  }
};

MeetAjaxForProduct.prototype.meetProductClick = function () {
  if (this.meetProductpagination) {
    this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.addEventListener("click", this.meetStopProductMultipleClicks);
    }
  }
};

MeetAjaxForProduct.prototype.meetStopProductMultipleClicks = function (event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.data.loadingText;
    this.nextPageUrl = this.nextPageLinkElement ? this.nextPageLinkElement.href : null;
    if (this.nextPageUrl) {
      this.clickActive = false;
      this.loadMore();
    }
  }
};

MeetAjaxForProduct.prototype.meetProductPaginationlnView = function () {
  var top = this.meetProductpagination.getBoundingClientRect().top - this.data.offset;
  var bottom = this.meetProductpagination.getBoundingClientRect().bottom + this.data.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.data.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      if (this.nextPageUrl) {
        this.loadMore();
      }
    }
  }
};

MeetAjaxForProduct.prototype.loadMore = function () {
  var loaderElement = document.getElementById("loader");
  if (loaderElement) loaderElement.style.display = "block";

  setTimeout(() => {
    this.request = new XMLHttpRequest();
    this.request.onreadystatechange = function () {
      if (this.request.readyState === 4 && this.request.status === 200) {
        console.log(this.request.responseText); // Debugging

        var parser = new DOMParser();
        var responseDoc = parser.parseFromString(this.request.responseText, "text/html");

        var createdPagination = responseDoc.querySelector(this.data.pagination);
        var createdContainer = responseDoc.querySelector(this.data.container);

        if (createdPagination) {
          this.meetProductpagination.innerHTML = createdPagination.innerHTML;
        } else {
          this.meetProductpagination.innerHTML = "";
        }

        if (createdContainer) {
          this.meetProductcontainer.insertAdjacentHTML("beforeend", createdContainer.innerHTML);
        }

        if (this.data.callback && typeof this.data.callback === "function") {
          this.data.callback(responseDoc);
        }

        if (!responseDoc.querySelector(`${this.data.pagination} a`)) {
          console.log("Aucun autre produit à afficher.");
          this.removeScrollListener();
          if (loaderElement) loaderElement.style.display = "none";
        } else {
          this.meetProductInitialize();
        }
      }
    }.bind(this);

    this.request.open("GET", this.nextPageUrl);
    this.request.send();
  }, 2000);
};

MeetAjaxForProduct.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.meetProductPaginationlnView);
  window.removeEventListener("resize", this.meetProductPaginationlnView);
  window.removeEventListener("orientationchange", this.meetProductPaginationlnView);
};

MeetAjaxForProduct.prototype.meetProductDestroy = function () {
  var methods = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  if (methods[this.data.method]) {
    methods[this.data.method]();
  }
  return this;
};

MeetAjaxForProduct.prototype.removeClickListener = function () {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.meetStopProductMultipleClicks);
  }
};
